module.exports = __webpack_public_path__ + "static/equipment_management-cb7393e632002058c0290416f3c5fb0c.jpg";